window.copyToClipboard = async function (text, e) {
  if (e && e.preventDefault) e.preventDefault();
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.warn('Unable to copy.', error);
  }
}
